/*
 * @Description:
 * @Version: 2.0
 * @Date: 2023-10-20 14:14:56
 * @LastEditTime: 2025-05-28 14:09:04
 * @Author: Auerbach
 * @LastEditors: Auerbach
 */
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router"
import LayoutPlatform from '@/layout/index.vue'
import { getStorage, treetolist } from "@/utils/common"
// import NProgress from 'nprogress'
import { ElNotification, ElLoading } from "element-plus"

const Routes: RouteRecordRaw[] = [
  // 登录
  {
    path: "/login",
    name: "login",
    component: () => import("@/pages/login/default/index.vue"),
  },
  // 医生端注册
  // {
  //   path: "/register",
  //   name: "register",
  //   component: () => import("@/pages/login/register/index.vue"),
  // },
  // {
  //   path: "/dashboard",
  //   name: "dashboard",
  //   component: () => import("@/pages/dashboard/index.vue"),
  // },
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/index",
    name: "index",
    component: () => import("@/pages/index/index.vue"),
  },
  // 404
  { 
    path: '/404',
    name: '/404',
    component: () => import('@/pages/other/404/index.vue')
  },
  { path: '/:catchAll(.*)', redirect: '/404' }
]

const router = createRouter({
  // history: createWebHistory(process.env.NODE_ENV === "production" ? '/' : '/agent/'),
  history: createWebHistory('/'),
  routes: Routes
})

const whiteList = ['/login', '/defaultIndex', '/expertRegister', '/expertLogin', '/hospitalLogin'] // no redirect whitelist

let loading
router.beforeEach(async (to, from, next) => {
  // const userinfo = getStorage('userinfo')
  // const menuList = getStorage('menuList')
  // const dicts = JSON.parse(localStorage.getItem('mrdicts') || '{}')
  // NProgress.start()
  // if (!dicts || isEmpty(dicts)) {
  //   const _dict = (await dictApi.getAllDict({})) || []
  //   localStorage.setItem('mrdicts', JSON.stringify(_dict))
  // }
  loading = ElLoading.service({
    lock: true,
    text: '加载中',
    background: 'rgba(9, 16, 12, 0.2)',
  })
  // if (to.path === '/404') {
    next()
  // } else if (userinfo.userCode && menuList?.length) {
  //   if (to.path === '/login') {
  //     next()
  //   } else {
  //     if (whiteList.indexOf(to.path) !== -1 || to.meta.passauth) {
  //       next()
  //     } else if (treetolist(menuList, 'childList').find(v => v.code == to.name || v.code == to.meta?.pname)) {
  //       next()
  //     } else {
  //       next({ path: '/404', replace: true })
  //     }
  //   }
  // } else {
  //   if (whiteList.indexOf(to.path) !== -1 || to.meta.passauth) {
  //     next()
  //   } else {
  //     ElNotification({
  //       type: 'warning',
  //       title: '未登录',
  //       message: '请重新登录'
  //     })
  //     next({ path: '/login', replace: true })
  //   }
  // }
})

router.afterEach(() => {
  // NProgress.done()
  loading?.close()
})

export default router
